<div data-cy="borrower-status-reason-dialog">
  <h2 mat-dialog-title>Disposition</h2>
  <ng-container *ngIf="data.selectedOption.value !== 'doNotContact'">
    <mat-dialog-content>
      <p class="tw-pt-3">Why are you moving this borrower to "{{ data.selectedOption.label }}"?</p>

      <form [formGroup]="form" id="borrower-status-reason-form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      </form>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        form="borrower-status-reason-form"
        [mat-dialog-close]="model"
        [disabled]="!form.valid"
        data-cy="borrower-status-reason-save"
      >Save</button>
    </mat-dialog-actions>
  </ng-container>

  <ng-container *ngIf="data.selectedOption.value === 'doNotContact'">

    <mat-dialog-content class="!tw-pt-2">

      <formly-form [form]="dncForm" [fields]="dncFields" [model]="dncModel"></formly-form>

      <p>Are you sure you want to move this borrower to "{{ data.selectedOption.label }}"?</p>
      <p>This business will be placed on a "Do Not Contact" list and this can be undone by a manager only.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="!dncForm.valid"
        [mat-dialog-close]="dncParams()"
      >Move to "Do Not Contact"</button>
    </mat-dialog-actions>
  </ng-container>
</div>
